/* fndry-press
   Mobile: one quote per screen, infinite loop, thumb tracks scroll.
   Desktop: plain grid, all of this stays asleep. */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 750px)';
  var instances = [];

  function reduceMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function Press(root) {
    this.root = root;
    this.rail = root.querySelector('[data-fp-rail]');
    this.track = root.querySelector('[data-fp-progress]');
    this.thumb = root.querySelector('[data-fp-thumb]');
    this.count = parseInt(root.getAttribute('data-fp-count'), 10) || 0;

    this.looping = false;
    this.stride = 0;
    this.base = 0;
    this.touching = false;
    this.frame = 0;
    this.idleTimer = 0;
    this.resizeTimer = 0;
    this.vw = document.documentElement.clientWidth;

    this.onScroll = this.onScroll.bind(this);
    this.onIdle = this.onIdle.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.sync = this.sync.bind(this);

    this.mq = window.matchMedia(DESKTOP);
    this.observeReveal();

    if (!this.rail || this.count < 1) return;

    this.rail.addEventListener('scroll', this.onScroll, { passive: true });
    this.rail.addEventListener('touchstart', this.onTouchStart, { passive: true });
    this.rail.addEventListener('touchend', this.onTouchEnd, { passive: true });
    this.rail.addEventListener('touchcancel', this.onTouchEnd, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (this.mq.addEventListener) this.mq.addEventListener('change', this.sync);
    else if (this.mq.addListener) this.mq.addListener(this.sync);

    this.sync();
  }

  Press.prototype.isMobile = function () {
    return !this.mq.matches;
  };

  /* ------------------------------------------------------------ reveal */

  Press.prototype.observeReveal = function () {
    var root = this.root;
    if (!('IntersectionObserver' in window)) {
      root.setAttribute('data-enter', '');
      return;
    }
    this.io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) root.setAttribute('data-enter', '');
          else if (entry.boundingClientRect.top > 0) root.removeAttribute('data-enter');
        });
      },
      { threshold: 0, rootMargin: '0px 0px -20% 0px' }
    );
    this.io.observe(root);
  };

  /* -------------------------------------------------------------- loop */

  Press.prototype.sync = function () {
    if (this.isMobile()) this.enable();
    else this.disable();
  };

  Press.prototype.realItems = function () {
    return Array.prototype.slice.call(this.rail.querySelectorAll('.fndry-press__item:not([data-fp-clone])'));
  };

  Press.prototype.enable = function () {
    if (this.looping) {
      this.measure();
      this.update();
      return;
    }

    var real = this.realItems();
    if (real.length > 1) {
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      real.forEach(function (item) {
        before.appendChild(cloneItem(item));
        after.appendChild(cloneItem(item));
      });
      this.rail.insertBefore(before, real[0]);
      this.rail.appendChild(after);
      this.rail.setAttribute('role', 'group');
      this.rail.setAttribute('aria-roledescription', 'carousel');
      this.looping = true;
    }

    this.measure();
    if (this.looping) this.rail.scrollLeft = this.base;
    this.update();
  };

  Press.prototype.disable = function () {
    if (this.looping) {
      var clones = this.rail.querySelectorAll('[data-fp-clone]');
      for (var i = 0; i < clones.length; i++) clones[i].parentNode.removeChild(clones[i]);
      this.rail.removeAttribute('role');
      this.rail.removeAttribute('aria-roledescription');
      this.looping = false;
    }
    this.rail.scrollLeft = 0;
    this.base = 0;
  };

  function cloneItem(item) {
    var clone = item.cloneNode(true);
    clone.setAttribute('data-fp-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-fp-block-id');
    clone.removeAttribute('id');
    var focusable = clone.querySelectorAll('a, button, [tabindex]');
    for (var i = 0; i < focusable.length; i++) focusable[i].setAttribute('tabindex', '-1');
    return clone;
  }

  /* ------------------------------------------------------- measurement */

  Press.prototype.measure = function () {
    var kids = this.rail.children;
    if (kids.length > 1) {
      var a = kids[0].getBoundingClientRect();
      var b = kids[1].getBoundingClientRect();
      this.stride = b.left - a.left;
    } else {
      this.stride = this.rail.clientWidth;
    }
    if (!this.stride) this.stride = this.rail.clientWidth || 1;
    this.base = this.looping ? this.count * this.stride : 0;
  };

  Press.prototype.position = function () {
    if (!this.stride) return 0;
    return (this.rail.scrollLeft - this.base) / this.stride;
  };

  /* ------------------------------------------------------------ scroll */

  Press.prototype.onScroll = function () {
    var self = this;
    if (!this.frame) {
      this.frame = requestAnimationFrame(function () {
        self.frame = 0;
        self.update();
      });
    }
    clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(this.onIdle, 140);
  };

  Press.prototype.onTouchStart = function () {
    this.touching = true;
  };

  Press.prototype.onTouchEnd = function () {
    var self = this;
    this.touching = false;
    clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(this.onIdle, 220);
  };

  // Teleport back into the middle set once the flick has settled. Snapping is
  // finished by now, so setting scrollLeft lands exactly and doesn't fight it.
  Press.prototype.onIdle = function () {
    if (!this.looping || this.touching || !this.isMobile()) return;
    var i = Math.round(this.position());
    if (i < 0 || i >= this.count) {
      var norm = ((i % this.count) + this.count) % this.count;
      this.rail.scrollLeft = this.base + norm * this.stride;
      this.update();
    }
  };

  Press.prototype.update = function () {
    if (!this.thumb || !this.track || this.count < 1) return;
    var trackWidth = this.track.clientWidth;
    if (!trackWidth) return;

    var thumbWidth = trackWidth / this.count;
    var p = this.position() % this.count;
    if (p < 0) p += this.count;

    var x = p * thumbWidth;
    if (x < 0) x = 0;
    if (x > trackWidth - thumbWidth) x = trackWidth - thumbWidth;

    this.thumb.style.transform = 'translateX(' + x + 'px)';
  };

  /* P15 sitewide 2026-10-23: a resize that keeps the width is the phone
     toolbar collapsing or coming back. It used to re-measure and re-seat the
     logo rail's scroll position each time; nothing here depends on height. */
  Press.prototype.onResize = function () {
    var self = this;
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(function () {
      var w = document.documentElement.clientWidth;
      if (w === self.vw) return;
      self.vw = w;
      if (!self.isMobile()) return;
      var index = Math.round(self.position());
      self.measure();
      if (self.looping) {
        var norm = ((index % self.count) + self.count) % self.count;
        self.rail.scrollLeft = self.base + norm * self.stride;
      }
      self.update();
    }, 150);
  };

  /* --------------------------------------------------- editor / preview */

  Press.prototype.goToBlock = function (blockId) {
    if (!this.rail || !this.isMobile()) return;
    var target = this.rail.querySelector('[data-fp-block-id="' + blockId + '"]');
    if (!target) return;
    var delta = target.getBoundingClientRect().left - this.rail.getBoundingClientRect().left;
    var left = this.rail.scrollLeft + delta;
    if (reduceMotion() || !this.rail.scrollTo) {
      this.rail.scrollLeft = left;
      this.update();
    } else {
      this.rail.scrollTo({ left: left, behavior: 'smooth' });
    }
  };

  Press.prototype.destroy = function () {
    if (this.io) this.io.disconnect();
    clearTimeout(this.idleTimer);
    clearTimeout(this.resizeTimer);
    if (this.frame) cancelAnimationFrame(this.frame);
    window.removeEventListener('resize', this.onResize);
    if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.sync);
    else if (this.mq.removeListener) this.mq.removeListener(this.sync);
    if (this.rail) {
      this.rail.removeEventListener('scroll', this.onScroll);
      this.rail.removeEventListener('touchstart', this.onTouchStart);
      this.rail.removeEventListener('touchend', this.onTouchEnd);
      this.rail.removeEventListener('touchcancel', this.onTouchEnd);
    }
  };

  /* --------------------------------------------------------------- init */

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fp-root]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.getAttribute('data-fp-ready') === 'true') continue;
      root.setAttribute('data-fp-ready', 'true');
      try {
        instances.push(new Press(root));
      } catch (err) {
        // Never let a broken script be the only thing holding the copy hidden.
        root.setAttribute('data-enter', '');
        if (window.console && console.warn) console.warn('fndry-press:', err);
      }
    }
  }

  function find(root) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].root === root) return instances[i];
    }
    return null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-fp-root]');
    var found = root && find(root);
    if (found) {
      found.destroy();
      instances.splice(instances.indexOf(found), 1);
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest ? event.target.closest('[data-fp-root]') : null;
    var found = root && find(root);
    if (found) found.goToBlock(event.target.getAttribute('data-fp-block-id') || event.detail.blockId);
  });
})();